"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalBody = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const LlmAnswer_1 = require("./LlmAnswer");
const UserPrompt_1 = require("./UserPrompt");
const EditPrompt_1 = require("./EditPrompt");
const PromptSelect_1 = require("./PromptSelect");
const ModalContext_1 = require("../context/ModalContext");
const ModalBody = () => {
    const context = (0, react_1.useContext)(ModalContext_1.ModalContext);
    return ((0, jsx_runtime_1.jsxs)("div", { className: "modal-body", children: [(0, jsx_runtime_1.jsx)("div", { className: "wpj-form-group d-flex gap-1", children: (0, jsx_runtime_1.jsx)(PromptSelect_1.PromptSelect, {}) }), !context.loading && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(UserPrompt_1.UserPrompt, {}), (!!context.responses.length || context.loadingResponse) && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", { className: "wpj-form-group", children: (0, jsx_runtime_1.jsx)(LlmAnswer_1.LlmAnswer, {}) }), (0, jsx_runtime_1.jsx)("div", { className: "wpj-form-group wpj-form-group-flex d-flex gap-1", children: (0, jsx_runtime_1.jsx)(EditPrompt_1.EditPrompt, {}) })] }))] }))] }));
};
exports.ModalBody = ModalBody;
